export default "__VITE_ASSET__C2vuzmu5__"